import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ScrollRestoration = () => {
  const { pathname } = useLocation();
  const [page, setPage] = useState(pathname);
  const temp = pathname.split("/");
  const pageArray = page.split("/");

  useEffect(() => {
    // if (
    //   temp[temp.length - 2] === pageArray[pageArray.length - 1] ||
    //   temp[temp.length - 1] === pageArray[pageArray.length - 1]
    // ) {
    //   setPage(pathname);
    // } else {
    //   window.scrollTo(0, 0);
    //   setPage(pathname);
    // }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default ScrollRestoration;
